import Vue from 'vue'
import Router from 'vue-router'
import router_view from '@/router_view'

import login from '@/auth/login'
import change_password from '@/auth/change_password'

import home from '@/pages/home/index'
import detail_report from '@/pages/home/detail_report'
import user from '@/pages/user/index'
import user_add from '@/pages/user/add'
import user_detail from '@/pages/user/detail'
import user_detail_agent from '@/pages/user/detail_agent'
import user_detail_mitra from '@/pages/user/detail_mitra'
import document_action from '@/pages/user/action_document'
import health_history_action from '@/pages/user/action_health_history'
import job_history_action from '@/pages/user/action_job_history'
import order from '@/pages/order/index'
import order_membership from '@/pages/order_membership/index'
import order_detail from '@/pages/order/detail'
import order_call from '@/pages/order_call/index'
import order_call_rating from '@/pages/order_call/rating'
import order_call_detail from '@/pages/order_call/detail'
import order_call_pick from '@/pages/order_call/pick_helper'
import order_recruit from '@/pages/order_recruit/index'
import order_recruit_detail from '@/pages/order_recruit/detail'
import order_recruit_rating from '@/pages/order_recruit/rating'
import contract from '@/pages/contract/index'
import contract_detail from '@/pages/contract/detail'
import point from '@/pages/point/index'
import point_detail from '@/pages/point/detail'
import point_add from '@/pages/point/add'
import point_subtract from '@/pages/point/subtract'
import news from '@/pages/news/index'
import news_detail from '@/pages/news/action'
import jobs from '@/pages/jobs/index'
import jobs_detail from '@/pages/jobs/action'
import chat from '@/pages/chat/index'
import chat_detail from '@/pages/chat/action'
import voucher from '@/pages/voucher/index'
import voucher_detail from '@/pages/voucher/action'
import discount from '@/pages/discount/index'
import discount_detail from '@/pages/discount/action'
import article from '@/pages/article/index'
import article_detail from '@/pages/article/action'
import online_test from '@/pages/online_test/index'
import online_test_detail from '@/pages/online_test/detail'
import online_test_action from '@/pages/online_test/action'
import banner from '@/pages/banner/index'
import banner_action from '@/pages/banner/action'
import support from '@/pages/support/index'
import support_action from '@/pages/support/action'
import communication from '@/pages/communication/index'
import communication_action from '@/pages/communication/action'
import communication_detail from '@/pages/communication/detail'
import referral from '@/pages/referral/index'

import bundle_packet from '@/pages/master/bundle_packet/index'
import bundle_packet_action from '@/pages/master/bundle_packet/action'
import city from '@/pages/master/city/index'
import city_action from '@/pages/master/city/action'
import nominal_point from '@/pages/master/nominal_point/index'
import nominal_point_action from '@/pages/master/nominal_point/action'
import sub_district from '@/pages/master/sub_district/index'
import sub_district_action from '@/pages/master/sub_district/action'
import app_version from '@/pages/master/app_version/index'
import app_version_action from '@/pages/master/app_version/action'
import religion from '@/pages/master/religion/index'
import province from '@/pages/master/province/index'
import tribe from '@/pages/master/tribe/index'
import helper_category from '@/pages/master/helper_category/index'
import helper_category_action from '@/pages/master/helper_category/action'
import helper_sub_category from '@/pages/master/helper_sub_category/index'
import helper_sub_category_action from '@/pages/master/helper_sub_category/action'
import helper_sub_sub_category from '@/pages/master/helper_sub_sub_category/index'
import helper_sub_sub_category_action from '@/pages/master/helper_sub_sub_category/action'
import communication_method from '@/pages/master/communication_method/index'
import communication_type from '@/pages/master/communication_type/index'
import education from '@/pages/master/education/index'
import experience from '@/pages/master/experience/index'
import experience_action from '@/pages/master/experience/action'
import expected_salary from '@/pages/master/expected_salary/index'
import expected_salary_action from '@/pages/master/expected_salary/action'
import contract_type from '@/pages/master/contract_type/index'
import skill from '@/pages/master/skill/index'
import blood_type from '@/pages/master/blood_type/index'
import setting from '@/pages/master/setting/index'
import setting_action from '@/pages/master/setting/action'
import setting_referral from '@/pages/master/setting_referral/index'
import setting_interval from '@/pages/master/setting_interval/index'
import setting_point from '@/pages/master/setting_point/index'
import setting_point_action from '@/pages/master/setting_point/action'
import setting_email from '@/pages/master/setting_email/index'
import setting_email_action from '@/pages/master/setting_email/action'
import setting_price from '@/pages/master/setting_price/index'
import setting_price_action from '@/pages/master/setting_price/action'

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '',
      component: home,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/report/detail',
      component: detail_report,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/referral',
      component: referral,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/change-password',
      component: change_password,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/auth',
      component: router_view,
      children:[
        {
          path: 'login',
          component: login,
        },
      ]
    },
    {
      path: '/document',
      component: router_view,
      children:[
        {
          path: 'action',
          component: document_action,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/health-history',
      component: router_view,
      children:[
        {
          path: 'action',
          component: health_history_action,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/job-history',
      component: router_view,
      children:[
        {
          path: 'action',
          component: job_history_action,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/user',
      component: router_view,
      children:[
        {
          path: '',
          component: user,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'action',
          component: router_view,
          children:[
            {
              path: '',
              component: user_detail,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'agent',
              component: user_detail_agent,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'mitra',
              component: user_detail_mitra,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'add',
          component: user_add,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/order',
      component: router_view,
      children:[
        {
          path: '',
          component: order,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'detail',
          component: order_detail,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
		{
			path: '/order-membership',
			component: router_view,
			children:[
				{
					path: '',
					component: order_membership,
					meta: {
						requiresAuth: true
					},
				},
			]
		},
    {
      path: '/order-call',
      component: router_view,
      children:[
        {
          path: '',
          component: order_call,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'detail',
          component: order_call_detail,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'choose',
          component: order_call_pick,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'rating',
          component: order_call_rating,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/order-recruit',
      component: router_view,
      children:[
        {
          path: '',
          component: order_recruit,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'detail',
          component: order_recruit_detail,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'rating',
          component: order_recruit_rating,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/contract',
      component: router_view,
      children:[
        {
          path: '',
          component: contract,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'detail',
          component: contract_detail,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/support',
      component: router_view,
      children:[
        {
          path: '',
          component: support,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'action',
          component: support_action,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/point',
      component: router_view,
      children:[
        {
          path: '',
          component: point,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'detail',
          component: point_detail,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'add',
          component: point_add,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'subtract',
          component: point_subtract,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/banner',
      component: router_view,
      children:[
        {
          path: '',
          component: banner,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'action',
          component: banner_action,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/communication',
      component: router_view,
      children:[
        {
          path: '',
          component: communication,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'action',
          component: communication_action,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'detail',
          component: communication_detail,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/news',
      component: router_view,
      children:[
        {
          path: '',
          component: news,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'action',
          component: news_detail,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
		{
			path: '/jobs',
			component: router_view,
			children:[
				{
					path: '',
					component: jobs,
					meta: {
						requiresAuth: true
					},
				},
				{
					path: 'action',
					component: jobs_detail,
					meta: {
						requiresAuth: true
					},
				},
			]
		},
    {
      path: '/chat',
      component: router_view,
      children:[
        {
          path: '',
          component: chat,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'action',
          component: chat_detail,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/voucher',
      component: router_view,
      children:[
        {
          path: '',
          component: voucher,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'action',
          component: voucher_detail,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/discount',
      component: router_view,
      children:[
        {
          path: '',
          component: discount,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'action',
          component: discount_detail,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/article',
      component: router_view,
      children:[
        {
          path: '',
          component: article,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'action',
          component: article_detail,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/online-test',
      component: router_view,
      children:[
        {
          path: '',
          component: online_test,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'detail',
          component: online_test_detail,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'action',
          component: online_test_action,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
    {
      path: '/setting',
      component: router_view,
      children:[
				{
					path: '/',
					component: router_view,
					children: [
						{
							path: '',
							component: setting,
							meta: {
								requiresAuth: true
							},
						},
						{
							path: 'action',
							component: setting_action,
							meta: {
								requiresAuth: true
							},
						},
					]
				},
        {
          path: 'point',
          component: router_view,
          children: [
            {
              path: '',
              component: setting_point,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'action',
              component: setting_point_action,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'email',
          component: router_view,
          children: [
            {
              path: '',
              component: setting_email,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'action',
              component: setting_email_action,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'price',
          component: router_view,
          children: [
            {
              path: '',
              component: setting_price,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'action',
              component: setting_price_action,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'referral',
          component: router_view,
          children: [
            {
              path: '',
              component: setting_referral,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: '/',
          component: router_view,
          children: [
            {
              path: '',
              component: setting,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'interval',
          component: router_view,
          children: [
            {
              path: '',
              component: setting_interval,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
      ]
    },
    {
      path: '/master',
      component: router_view,
      children: [
        {
          path: 'religion',
          component: religion,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'experience',
          component: router_view,
          children: [
            {
              path: '',
              component: experience,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'action',
              component: experience_action,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'contract-type',
          component: contract_type,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'expected-salary',
          component: router_view,
          children: [
            {
              path: '',
              component: expected_salary,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'action',
              component: expected_salary_action,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'app-version',
          component: router_view,
          children: [
            {
              path: '',
              component: app_version,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'action',
              component: app_version_action,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'communication-method',
          component: communication_method,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'communication-type',
          component: communication_type,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'tribe',
          component: tribe,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'helper-category',
          component: router_view,
					children: [
						{
							path: '',
							component: helper_category,
							meta: {
								requiresAuth: true
							},
						},
						{
							path: 'action',
							component: helper_category_action,
							meta: {
								requiresAuth: true
							},
						},
					]
        },
        {
          path: 'helper-sub-category',
          component: router_view,
          children: [
            {
              path: '',
              component: helper_sub_category,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'action',
              component: helper_sub_category_action,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'helper-sub-sub-category',
          component: router_view,
          children: [
            {
              path: '',
              component: helper_sub_sub_category,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'action',
              component: helper_sub_sub_category_action,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'bundle-packet',
          component: router_view,
          children: [
            {
              path: '',
              component: bundle_packet,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'action',
              component: bundle_packet_action,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'city',
          component: router_view,
          children: [
            {
              path: '',
              component: city,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'action',
              component: city_action,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'nominal-point',
          component: router_view,
          children: [
            {
              path: '',
              component: nominal_point,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'action',
              component: nominal_point_action,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'sub-district',
          component: router_view,
          children: [
            {
              path: '',
              component: sub_district,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'action',
              component: sub_district_action,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'province',
          component: province,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'education',
          component: education,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'skill',
          component: skill,
          meta: {
            requiresAuth: true
          },
        },
        {
          path: 'blood-type',
          component: blood_type,
          meta: {
            requiresAuth: true
          },
        },
      ]
    },
  ],
  mode: 'history',
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      sessionStorage.setItem('redirect',to.fullPath)
      next({
        path: '/auth/login',
      })
    }
    else
      next()
  }
  else
    next()
})

export default router
